export const MAX_FILE_SIZE = 10 * Math.pow(1024, 2);
export const NOTIFICATION_LOADING_INTERVAL = 1000 * 15;
export const MIN_QUERY_SIZE = 3;
